export function getClassName(type: string) {
  switch (type) {
    case 'integer':
      return 'text-end';
    case 'number':
      return 'text-end';
    case 'boolean':
      return 'text-center';
    default:
      return 'text-start';
  }
}
